import { Component, ContentChildren, QueryList } from '@angular/core';

import { GasColor } from '../../../core/colors/color.namespace';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasStepsComponent } from '../steps/gas-steps.component';

const CORRECT_LENGTH = 1;

@Component({
  selector: 'gas-horizontal-steps',
  templateUrl: './gas-horizontal-steps.component.html',
  styleUrls: ['./gas-horizontal-steps.component.scss'],
})
export class GasHorizontalStepsComponent {
  /** Шаги */
  @ContentChildren(GasStepsComponent)
  public steps: QueryList<GasStepsComponent>;

  public getLineColor(status: string): string {
    return status === GasIcon.Notifications.Success ? GasColor.Color.SuccessDark : GasColor.Color.Disabled;
  }

  public setRightLine(index: number): boolean {
    return index < this.steps.length - CORRECT_LENGTH;
  }
}
